module.exports = __webpack_public_path__ + "static/media/Read-Regular_V1100.659ed096.eot";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/read/Read-Regular_V1100.eot
// module id = 919
// module chunks = 0